import PropTypes from 'prop-types';
import React from 'react';

import * as Items from './index.js';

/* ========================================================================= */
/* Method(s) */
/* ========================================================================= */

/**
 * Get carousel width classes for calendar listing item type
 * @param {string} itemType
 * @param {number} carouselItemIndex
 * @returns {string}
 */
const getCssClassForItemType = (itemTypeName, carouselItemIndex) => {
    let slideClassName = '';

    switch (itemTypeName) {
    case 'AnnouncementDetailPage':
    case 'ArticleDetailPage':
    case 'CourseDetailPage':
    case 'EventDetailPage':
    case 'ProgrammeDetailPage':
    case 'SecondaryTestimonialCarouselItemBlock':
        if (carouselItemIndex === 0) {
            slideClassName = 'flex flex-wrap w-11/12 sm:w-6/12 md:w-5/12';
        } else {
            slideClassName = 'flex flex-wrap w-11/12 sm:w-6/12 md:w-4/12';
        }
        break;

    case 'JobDetailPage':
        if (carouselItemIndex === 0) {
            slideClassName = 'flex flex-wrap w-12/12 sm:w-6/12 md:w-5/12';
        } else {
            slideClassName = 'flex flex-wrap w-12/12 sm:w-6/12 md:w-4/12';
        }
        break;

    case 'MediaCarouselItemBlockLandscape':
    case 'NarrowCarouselItemBlockLandscape':
        slideClassName = 'w-9/12 sm:w-8/12 md:w-5/12';
        break;

    case 'MediaCarouselItemBlockPortrait':
    case 'NarrowCarouselItemBlockPortrait':
        slideClassName = 'w-6/12 sm:w-3/12';
        break;

    case 'MediaCarouselItemBlockSquare':
    case 'NarrowCarouselItemBlockSquare':
        slideClassName = 'w-3/12 sm:w-2/12 md:w-4/12';
        break;

    case 'PersonDetailPage':
        slideClassName = 'w-6/12 sm:w-4/12 md:w-2/12';
        break;

    case 'RelatedPeople':
        slideClassName = 'w-6/12 sm:w-4/12 md:w-2/12';
        break;

    case 'PrimaryTestimonialCarouselItemBlock':
        slideClassName = 'w-12/12';
        break;

    case 'ProgrammeCarouselItemBlock':
        if (carouselItemIndex === 0) {
            slideClassName = 'flex flex-wrap w-12/12 sm:w-6/12 md:w-6/12';
        } else {
            slideClassName = 'flex flex-wrap w-12/12 sm:w-6/12 md:w-5/12';
        }
        break;

    case 'ArticleDetailPageAlternative':
        if (carouselItemIndex === 0) {
            slideClassName = 'flex flex-wrap w-12/12 sm:w-6/12 md:w-5/12';
        } else {
            slideClassName = 'flex flex-wrap w-12/12 sm:w-6/12 md:w-4/12';
        }
        break;

    default:
        break;
    }

    return slideClassName;
};

/* ========================================================================= */
/* Component(s) */
/* ========================================================================= */

const CarouselItemDispatcher = (props) => {
    if (!props?.__typename) {
        return null;
    }

    let CarouselItem = null;

    switch (props.__typename) {
    case 'AnnouncementDetailPage':
    case 'CourseDetailPage':
    case 'EventDetailPage':
    case 'ProgrammeDetailPage':
        CarouselItem = Items['CarouselItemCalendarDetailPage'];
        break;

    case 'MediaCarouselItemBlockLandscape':
    case 'MediaCarouselItemBlockPortrait':
    case 'MediaCarouselItemBlockSquare':
    case 'NarrowCarouselItemBlockLandscape':
    case 'NarrowCarouselItemBlockPortrait':
    case 'NarrowCarouselItemBlockSquare':
        CarouselItem = Items['CarouselItemMediaBlock'];
        break;

    case 'ProgrammeCarouselItemBlock':
        CarouselItem = Items['CarouselItemProgrammeCarouselItem'];
        break;

    default:
        CarouselItem = Items['CarouselItem' + props.__typename];
        break;
    }

    if (!CarouselItem) {
        return null;
    }

    return (
        <CarouselItem { ...props } />
    );
};

/* ========================================================================= */
/* Typing and exports */
/* ========================================================================= */

CarouselItemDispatcher.propTypes = {
    __typename: PropTypes.string.isRequired
};

export {
    CarouselItemDispatcher,
    getCssClassForItemType
};

export default CarouselItemDispatcher;
